import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';

import { DataFoundryLanding } from '@/components/features/data-foundry/DataFoundryLanding';
import { useAppConfiguration } from '@/context/AppConfigurationContext';

export const Route = createFileRoute('/_protected/t/$tenantId/data-foundry/')({
  validateSearch: z.object({
    chatConversationId: z.string().optional().catch(undefined),
  }),
  component: DataFoundryRoute,
  ssr: false,
});

function DataFoundryRoute() {
  const { selectedTenant } = useAppConfiguration();
  const tenantId = selectedTenant?.tenant_id;
  const { chatConversationId } = Route.useSearch();

  return <DataFoundryLanding key={tenantId ?? 'default'} tenantId={tenantId} chatConversationId={chatConversationId} />;
}
